module.exports = __webpack_public_path__ + "img/logo.19a79a85.png";